export const ROUTE_DASHBOARD = '/' as const;
export const ENV: string = import.meta.env.VITE_ENV;
